import { render, staticRenderFns } from "./ActionBanner.vue?vue&type=template&id=b87118cc&scoped=true"
import script from "./ActionBanner.vue?vue&type=script&lang=js"
export * from "./ActionBanner.vue?vue&type=script&lang=js"
import style0 from "./ActionBanner.vue?vue&type=style&index=0&id=b87118cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87118cc",
  null
  
)

export default component.exports